/* eslint-disable react/prop-types */
import React from "react"

import ReceiptOfInvoicePrint from "./ReceiptOfInvoicePrint"

const ReceiptOfInvoicePrintLayout = React.forwardRef(
  ({ data, classes }, ref) => {
    return (
      <div ref={ref} className={classes.printWrapper}>
        {/* copy pertama */}
        <ReceiptOfInvoicePrint data={data} classes={classes} />

        {/* garis putus-putus pembatas */}
        <div className={classes.printDivider} />

        {/* copy kedua */}
        <ReceiptOfInvoicePrint data={data} classes={classes} />
      </div>
    )
  }
)

export default ReceiptOfInvoicePrintLayout
